import { ImageUploaderComponent, ValidImageResult } from '../../../../../Design/image-uploader/image-uploader.component';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppTheme } from '../../../../../services/theme/theme.service';
import { Tab } from '../../types';

@Component({
  selector: 'app-tab-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, ImageUploaderComponent],
  providers: [],
  templateUrl: './tab-modal.component.html',
  styleUrls: ['./tab-modal.component.scss'],
})
export class TabModalComponent {
  @Input() isTabModalOpen = false;
  @Input() isEditingTab = false;
  @Input() themes: AppTheme[] = [];
  @Input() newTabForm: Partial<Tab> = {
    name: '',
    icon_url: '',
    theme_name: '',
    search_placeholder: 'Search...',
    is_active: false,
  };

  @Output() modalClosed = new EventEmitter<void>();
  @Output() tabSaved = new EventEmitter<Partial<Tab>>();

  isUploadingImage = false;

  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);

  
  onFilesValid(files: ValidImageResult[]) {
    if (!files || files.length === 0) return;
    const file = files[0].file;
    const url = files[0].url;

    this.newTabForm._pending_file = file;
    this.newTabForm.icon_url = url;
  }

  removeIcon() {
    this.newTabForm._pending_file = undefined;
    this.newTabForm.icon_url = '';
  }


  get currentTheme(): AppTheme | undefined {
    return (
      this.themes.find((t) => t.id === this.newTabForm.theme_id) ||
      this.themes.find((t) => t.name === this.newTabForm.theme_name) ||
      this.themes[0]
    );
  }

  selectTheme(theme: AppTheme) {
    this.newTabForm.theme_id = theme.id;
    this.newTabForm.theme_name = theme.name;
  }

  get headerStyle(): string {
    const config = this.currentTheme?.theme_config;
    if (!config) return '';
    if (config.headerBackgroundType === 'solid') return config.headerColorStart;
    return `linear-gradient(to bottom, ${config.headerColorStart}, ${config.headerColorEnd})`;
  }

  close() {
    this.modalClosed.emit();
  }

  get safeSvg(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml('');
  }

  save() {
    if (!this.newTabForm.name?.trim()) return;
    const selectedTheme = this.currentTheme;
    this.newTabForm.theme_id = selectedTheme?.id;
    this.newTabForm.theme_name = selectedTheme?.name || '';
    this.tabSaved.emit(this.newTabForm);
  }

  navigateToThemes() {
    this.router.navigate(['/content/themes']);
    this.close();
  }
}
